import { render, staticRenderFns } from "./PhoneLink.vue?vue&type=template&id=d819c1a4&scoped=true"
import script from "./PhoneLink.vue?vue&type=script&lang=js"
export * from "./PhoneLink.vue?vue&type=script&lang=js"
import style0 from "./PhoneLink.vue?vue&type=style&index=0&id=d819c1a4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d819c1a4",
  null
  
)

export default component.exports